import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  Root,
  ImageContainer,
  ContentContainer,
  LogoImage,
  Title,
  Desc,
} from './StrategiesBanner.style';

import logoSrc from '../../assets/logo-strategies-black.png';

import { Button } from '../../ui/Button/Button';
import { Link } from '../Link/Link';

export const StrategiesBanner = () => {
  return (
    <Root>
      <ImageContainer />
      <ContentContainer>
        <LogoImage src={logoSrc} alt="Strategies Logo" />
        <Title>
          <FormattedMessage defaultMessage="What sets Strategies apart?" />
        </Title>
        <Desc>
          <FormattedMessage defaultMessage="Strategies has been helping salon and spa owners build stronger, more profitable businesses for over 30 years. They specialize in systems that grow client retention, sales, and team culture." />
        </Desc>
        <Button
          as={Link}
          to="https://strategies.com/about-us"
          style={{ backgroundColor: '#e74391' }}
        >
          <FormattedMessage defaultMessage="LEARN MORE ABOUT STRATEGIES" />
        </Button>
      </ContentContainer>
    </Root>
  );
};
